import { SET_GALLERY, GET_GALLERY, DELETE_GALLERY, UPDATE_GALLERY } from "./actionType";

export const setGallery = (gallery) => {
    return{
        type: SET_GALLERY,
        payload: gallery,
    };
};

export const getGallery = (galleryData) => {
    return{
        type: GET_GALLERY,
        payload : galleryData,
    };
};

export const deleteGallery = (id) => {
    return {
      type: DELETE_GALLERY,
      payload: id,
    };
};

export const updateGallery = (updatedGallery) => {
    return {
      type: UPDATE_GALLERY,
      payload: updatedGallery, // The updated gallery data will be in the payload
    };
  };
  